import {
    inject,
    observer
} from 'mobx-react'
import {
    WeaTableNew
} from 'comsMobx'
const WeaTable = WeaTableNew.WeaTable;

@inject('hrmStaffPayrollSummary')
@observer
export default class SubTable extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.hrmStaffPayrollSummary.getResourceSalaryList();
    }

    componentWillUnmount() {
        this.props.hrmStaffPayrollSummary.resetTable({
            type: 'sub'
        });
    }

    render() {
        const {
            hrmStaffPayrollSummary,
        } = this.props, {
            subTable,
        } = hrmStaffPayrollSummary, {
            tableStore,
            colNum,
        } = subTable;

        return (
            <WeaTable 
                comsWeaTableStore={tableStore}
                hasOrder={true}
                needScroll={true}
                scroll={{x: colNum*100}}
            />
        )

    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/hrm/components/staffPayrollSummary/SubTable.js